/*
  KAPIBARAN 単品/セット選択バー（2026-09-16）

  kb-set-selector.liquid が埋め込んだ静的データ(<script data-kb-set-map>)を読み、
  単品/セットどちらを選んでも、Shopify標準の数量セレクター・カート追加ボタンが
  「今選んでいる方の正しいvariant」を指すように差し替えるだけの小さなスクリプト。

  商品データそのもの（在庫・GID）は一切変えない。ページを離れず選べるように
  見せているだけで、実際にカートへ入るのは選択に対応する本物のvariant id。
*/
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init(root) {
    var dataScript = root.querySelector('[data-kb-set-map]');
    if (!dataScript) return;

    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    var sectionId = data.sectionId;
    var priceEl = document.getElementById('price-' + sectionId);
    var priceHtml = {
      unit: (root.querySelector('[data-kb-set-price="unit"]') || {}).innerHTML || '',
      pack: (root.querySelector('[data-kb-set-price="pack"]') || {}).innerHTML || '',
    };
    var noteEl = root.querySelector('[data-kb-set-note]');
    var totalHintEl = root.querySelector('[data-kb-set-total]');
    var currentColor = data.initialColor;

    function getChoice() {
      var checked = root.querySelector('.kb-set__radio:checked');
      return checked ? checked.value : 'unit';
    }

    function findVariant(choice, color) {
      var pool = data[choice] && data[choice].variants ? data[choice].variants : [];
      for (var i = 0; i < pool.length; i++) {
        if (pool[i].color === color) return pool[i];
      }
      return pool[0] || null;
    }

    function setFormVariantId(variantId, available) {
      ['product-form-' + sectionId, 'product-form-installment-' + sectionId].forEach(function (formId) {
        var form = document.getElementById(formId);
        if (!form) return;
        var input = form.querySelector('input[name="id"]');
        if (!input) return;
        input.value = variantId != null ? variantId : '';
        input.disabled = !available;
      });
    }

    function setSubmitButtonState(available) {
      var button = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!button) return;
      var label = button.querySelector('span');
      var strings = (window.FoxTheme && FoxTheme.variantStrings) || {};
      if (available) {
        button.removeAttribute('disabled');
        button.style.pointerEvents = '';
        button.style.opacity = '';
        if (label) label.textContent = strings.addToCart || 'カートに追加';
      } else {
        button.setAttribute('disabled', 'disabled');
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.6';
        if (label) label.textContent = strings.soldOut || '売り切れ';
      }
    }

    function updateTotalHint(choice) {
      if (!totalHintEl) return;
      if (choice !== 'pack') {
        totalHintEl.hidden = true;
        totalHintEl.textContent = '';
        return;
      }
      var qtyInput = document.getElementById('Quantity-' + sectionId);
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;
      totalHintEl.hidden = false;
      totalHintEl.textContent = '2点セット × ' + qty + ' = 合計 ' + qty * 2 + '点のお届けになります。';
    }

    function refresh() {
      var choice = getChoice();
      var variant = findVariant(choice, currentColor);

      if (priceEl && priceHtml[choice]) {
        priceEl.innerHTML = priceHtml[choice];
      }
      if (noteEl) noteEl.hidden = choice !== 'pack';

      setFormVariantId(variant && variant.id, !!(variant && variant.available));
      setSubmitButtonState(!!(variant && variant.available));
      updateTotalHint(choice);
    }

    root.addEventListener('change', function (event) {
      if (event.target && event.target.classList.contains('kb-set__radio')) {
        refresh();
      }
    });

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      currentColor = variant.option1;
      refresh();
    });

    document.addEventListener('input', function (event) {
      if (event.target && event.target.id === 'Quantity-' + sectionId) {
        updateTotalHint(getChoice());
      }
    });

    refresh();
  }

  ready(function () {
    document.querySelectorAll('[data-kb-set-selector]').forEach(init);
  });
})();
